import DROPPABLE_LOCATION_IDS from './droppableLocationIds';
import generateDroppableLocationSetForSection from './generateDroppableLocationSetForSection';

const getDroppableLocations = (nonLaidOutLibraryItems, currentSections) => {
  return currentSections.map(generateDroppableLocationSetForSection).reduce(
    (x, y) => {
      return { ...x, ...y };
    },
    {
      [DROPPABLE_LOCATION_IDS.SOURCE_TRAY_ID]: {
        id: DROPPABLE_LOCATION_IDS.SOURCE_TRAY_ID,
        libraryItemIds: nonLaidOutLibraryItems.map((item) => item.id),
        className: 'library-item-source-tray',
        direction: 'vertical',
      },
    }
  );
};

export default getDroppableLocations;
